import { createTheme } from '@mui/material/styles';
import {typographyTheme} from "./CentricTheme";
const LRSTheme = createTheme({

    palette: {
        primary: {
            light: "#60AD5E",
            main: "#2E7D32",
            dark: "#005005",
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: "#1F8921",
            contrastText: '#FFFFFF',
        },
        error: {
            light: "#FECBD3",
            main: "#B31527",
            dark: "#6C000C",
            contrastText: '#FFFFFF',
        },
        warning: {
            main: "#ff9800",
        },
        info: {
            main: "#2196F3",
        },
        success: {
            main: "#4CAF50",
        },
        grey: {
            200: "rgba(158,158,158,0.20)",
            500: "rgba(158,158,158,0.50)",
            700: "rgba(158,158,158,0.70)",
        },
        white: {
            100: "rgba(255,255,255,100)",
        },
        neutral: {
            main: 'rgba(243,243,243,1)',
            dark: 'rgba(230,230,230,1)',
            contrastText: 'rgba(0,0,0,0.7)',
        },
        gold: {
            main: "#FFD700",
        },
        text: {
            primary: "rgba(0,0,0,0.7)",
            secondary: "rgba(0,0,0,0.6)",
            disabled: "rgba(0,0,0,0.38)",
        },
        background: {
            paper: "rgb(255,255,255)",
            default: "rgb(245,245,245)",
        }
    },
    typography: typographyTheme
})

export default LRSTheme;